import session from './session'
import apiurl from './baseurl'
import axios from 'axios'
//https://navandume-stg.navandu.net
//https://navandume-stg.navandu.net

export default {
  getTermsProduct(productname) {
    return axios.get(
      apiurl.navandume + 'api/terms-conditions-og/' + productname
    )
  },
  //ok
  getTermsGlobal() {
    return axios.get(apiurl.navandume + 'api/terms-conditions-global')
  },

  getJobcenters(administrative_area) {
    return axios.get(apiurl.navandume + 'api/jobcenters', {
      params: {
        country: 'es',
        administrative_area: administrative_area
      }
    })
  },

  getCountries() {
    return axios.get(apiurl.navandume + 'api/countries', {      
    })
  },

  getAdministrativeAreas(country) {
    return axios.get(apiurl.navandume + 'api/provinces', {
      params: {
        country: country,        
      }
    })
  }
  ,

  getSpecialities(country) {
    return axios.get(apiurl.navandume + 'api/specialties.json', {
      params: {
        country: country
      }
    })
  },
  //funciona
  validateDoctorData(professional_number, user_name, user_surname) {
    return axios.post(apiurl.navandume + 'api/collegiate/cgcom_validate', {
      professional_number,
      user_name,
      user_surname
    })
  },
  validatePremiumCode(code) {
    return axios.post(apiurl.navandume + 'rest/user-uniquecode-validate', {
      code
    })
  },
  submitFormContact(name, email, telef, consulta) {
    return axios.post(apiurl.navandume + 'rest/v1.1/webform/contact', {
      name,
      email,
      telef,
      consulta
    })
  },
  validatePremiumCodeAuth(code) {
    return session.post(apiurl.navandume + 'rest/user-uniquecode-validate', {
      code
    })
  },
  //https://navandu.me/api/og_navandu/subscribe?v2=1
  //context.state.premiumCode, logininfo.groupid, logininfo.terms
  subscribe(code, gid, terms, isApp) {
    let options = {}
    if (code.length !== 0 && isApp === false) {
      options.code = code
    }
    if (gid.length !== 0) {
      options.gid = gid
    }
    if (terms.length !== 0) {
      options.terms = terms
    }
    if (options.gid)
      return session.post(
        apiurl.navandume + 'api/og_navandu/subscribe?v2=1',
        options
      )
    else {
      return session.post(
        apiurl.navandume + 'rest/v1.0/terms-conditions/submit',
        options
      )
    }
    //else return session.post(apiurl.navandume+'api/og_navandu/subscribe?v2=1',{"code":code,"gid":gid,"terms":terms})
  },
  checkMail(email) {
    return session.post(apiurl.navandume + 'rest/checkemail', {
      email
    })
  },
  getRegisterConfiguration() {
    return session.get(apiurl.proxy + 'api/v1.0/user-register-fields')
  }
}
